import React, { useState } from "react";
import axios from "axios";
import { Button } from "./ui/button";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HiredSignalBox = ({ jobId, compact = false }) => {
  const token = localStorage.getItem("token");
  const [step, setStep] = useState("idle");
  const [allowName, setAllowName] = useState(true);
  const [sending, setSending] = useState(false);

  if (!token) return null;

  const submit = async () => {
    setSending(true);
    try {
      await axios.post(
        `${API}/vaga/${jobId}/hired-signal`,
        { allow_name: allowName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStep("done");
      toast.success("Parabéns! 🎉 Avisamos a equipe — obrigado por contar.");
    } catch (e) {
      if (e.response?.status === 409) {
        setStep("done");
        toast.info("Você já sinalizou esta vaga. Obrigado!");
      } else {
        toast.error("Não foi possível enviar agora. Tente de novo.");
      }
    } finally {
      setSending(false);
    }
  };

  if (step === "done") {
    return (
      <p className="text-xs text-green-700 mt-2" data-testid={`hired-done-${jobId}`}>
        🎉 Obrigado por avisar! A equipe vai confirmar a contratação.
      </p>
    );
  }

  if (step === "form") {
    return (
      <div className="border border-green-200 bg-green-50 rounded-lg p-3 mt-2" data-testid={`hired-form-${jobId}`}>
        <p className="text-sm font-medium text-green-900">Que ótima notícia! 🎉 Só confirma para a gente:</p>
        <label className="flex items-start gap-2 text-xs text-green-800 mt-2 cursor-pointer">
          <input
            type="checkbox"
            checked={allowName}
            onChange={(e) => setAllowName(e.target.checked)}
            className="mt-0.5"
            data-testid={`hired-allow-name-${jobId}`}
          />
          Autorizo divulgar meu primeiro nome e cidade no post de comemoração (ex: "João, de Votuporanga, foi contratado!")
        </label>
        <div className="flex flex-wrap gap-2 mt-2">
          <Button size="sm" onClick={submit} disabled={sending} className="bg-green-700 hover:bg-green-800" data-testid={`hired-confirm-${jobId}`}>
            {sending ? "Enviando..." : "🤝 Confirmar: fui contratado"}
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setStep("idle")} data-testid={`hired-cancel-${jobId}`}>
            Cancelar
          </Button>
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={() => setStep("form")}
      className={`text-xs text-green-700 underline block ${compact ? "mt-1" : "mt-2"}`}
      data-testid={`hired-signal-btn-${jobId}`}
    >
      🤝 Fui contratado nessa vaga
    </button>
  );
};
